import { render, staticRenderFns } from "./ForWho.vue?vue&type=template&id=a3c88880&"
import script from "./ForWho.vue?vue&type=script&lang=js&"
export * from "./ForWho.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports